export const IPFS_IMAGE_CID = {
	defaultButton: 'QmcfuotN4KFwHAFwiqZ8ELALEUKzc7gvi1GfquEHM4fDjH',
	disabledButton: 'QmdPXyTmbDUwqgwPzspwceK3JthxY48mcsZrskDGVzRrQj',

	header0: 'QmQ8Bb97BpW8iYjCWvXCpck9H8ZmuwgafF4BhzirSzfg7j',
	'header0.1': 'QmQ8Bb97BpW8iYjCWvXCpck9H8ZmuwgafF4BhzirSzfg7j',
	header1: 'QmT9NXhaSRAGDAd7hdbdLGtyEaxkXbhiizi6L2hfX1L5nt',
	'header1.1': 'QmT9NXhaSRAGDAd7hdbdLGtyEaxkXbhiizi6L2hfX1L5nt',
	header2: 'QmdydD4zyA4ZTMmFZTP4uwBm5JwzSWZME5QXoXdvYBcETv',
	'header2.1': 'QmdydD4zyA4ZTMmFZTP4uwBm5JwzSWZME5QXoXdvYBcETv',
	header3: 'Qmc1Rvp5ngUUQqa3USbtMePuEt1vDJ8WWDpKS15uL4Nm5p',
	'header3.1': 'QmNewh2BKS8xgiCu5NaPfTRMfRjwzo2iY5r4yauWt4Jnab',
	header4: 'QmPX2nUsh8dmtZGCxZ3szzJjgxs33X7DqiQqH4JSehF2w8',
	'header4.1': 'QmdiN1jcVgSbZeeYvZ2kJsdQcG36HC6b4yQoBVa88Lcuab',
	header5: 'QmTzksn1PpaAWrcmwYCzW2XiSfXfefuVKQET1EcHduSk9k',
	'header5.1': 'QmYhDZJXsvKgssbw14jrgGs9pRx9Dsz3zbVffwrB36d1D6',
	header6: 'QmZxXCMLpqHT9Bz8nsTiZau1tKHeqFvucF9Pp99gYDsfq4',
	'header6.1': 'QmTM1KtPPGYyZXw4GkNt6V6QqqGPyRrQCwtUadqL6C4RHD',
	header7: 'QmZxXCMLpqHT9Bz8nsTiZau1tKHeqFvucF9Pp99gYDsfq4',
	'header7.1': 'QmTM1KtPPGYyZXw4GkNt6V6QqqGPyRrQCwtUadqL6C4RHD',

	cassette: 'QmUpwrWD8Aw2LuA7K9jxU16bwg35dBWaNDj8AuVc2wb7wG',
	datasette: 'Qmcf3MTQcUZGfRq9u27g1weoRuYds1AqhvWusV9BdFPeaw',
	delorean: 'Qma2AKVu7LB2WWeZfSuNqYfZYGq93pLn3JRBuVrW1mntyp',
	joystick: 'QmbYNNanixRfQap7bCSzAXAzzbKJgm7mwtRNBu97h8eMUF',
	keyboard: 'QmTqgADdsgYJ1TNjbvQxNj5b7dTsVQvdDVuNqNuKvoBXmA',
	monitor: 'QmQe27WKY6zymsMzBSviw4o2joDrMXNDjYQX114AoK29PY',

	scanlines: 'QmPbCmQJV9wvPBZFqfXpjNWczFkoG1nWr1LTUKBqtNWtPj',
	screen: 'QmULDwwNeSSE6vkGweet6gGrmuafxktdBsm4pT6t5wUVcY',

	step0: 'QmQsw41xR4eEP4D1mbdqMXyGAQzjJS5me16cxE7V5MuwkW',
	step1: 'QmQV4vtKZZWXHgSCVy4Gbx2TYMfuGAV7GCssrDktLEw3CY',
	step1done: 'QmPn29sA1e2mwKJzzaxbp5zmLyUm4fCodBUddqGFTYFKuS',
	step2: 'QmehGxXirbo4WznuPSkNeBRqgZACegw88zZCYjiNubLdmb',
	step2done: 'QmSLvwwSUN3oBBo13UNRhskiHt5QTgwaL32jnFLkq3hCnB',
	step3: 'QmUB2dV4tM2qthPW5MAiVt4kGLXWrfkwep3CxC8DUS58GG',
	step3done: 'QmeBk2RmZxvmmD1wiFCqcTzH1me8e7ddqZgXiVHrKgYMyR',
	step4: 'QmSGSKwez8PZw11vTPPBdqBFv8sXRdLk7aWSSdQ4BEmPPF',
	step4done: 'QmYDfzaEYzTWdz4Fh1TFZR24pYELyQzkqEefwxLspDsAas',
	step5: 'QmeZFYqw1YumAiM4braSh94Yr1J8CmAPALCh5EuJ3PNxgR',
	step5done: 'QmTK4v86NBaDPtiue8ZfRbTrPVZcLnvV5Mpz5ykzmDraNS',
	step6: 'QmRiTBB6yJdkt15wAtzc9XbD12N3DdzhPkYLF447RnP2eD',
	step6done: 'QmbMzkof6Vve6kyHiBk8nmFRPPf6nTcTso4K2461LKATtp',

	stepActive: 'QmczKj8F6YxeSttsE1SwRNGcb6u8mGUD67RCiXwkk95PEf',
	stepDisabled: 'QmNNT17qbT2p3dpumGL28bxMFi2CbGXZVJpD9vfKK86DaU',
	stepDone: 'QmSUSxMVpqKBiQdYq9wdj6Bxtg7aH3FDz1JCYkKYXkUWbQ',
}
